import { PP_DEFAULT_MOCK_PATIENT_ID } from '../patients/config';
import { resolvePatientMockBundleKey } from '../patients/utils';
import { PP_TREATMENT_BY_PATIENT } from './mockData';
import type { TpPatientTreatmentBundle } from './types';

export function getPatientTreatmentBundle(patientId: string): TpPatientTreatmentBundle {
  const key = resolvePatientMockBundleKey(patientId);
  return PP_TREATMENT_BY_PATIENT[key] ?? PP_TREATMENT_BY_PATIENT[PP_DEFAULT_MOCK_PATIENT_ID]!;
}

export function tpTotalOOP(treatments: TpPatientTreatmentBundle['treatments']): number {
  return treatments.reduce((sum, tx) => sum + tx.patientOOP, 0);
}
